/* Copyright (c) Epiphyte LLC 2022. All rights reserved.
Author: Fernandez-Alcon, Jose <jose@epiphyte.io>
 */

import React, { useState } from "react";
import {useAuth0} from "@auth0/auth0-react";
import {
    PageHeader
} from "grommet/components/PageHeader";
import {
    Box,
    Grid,
    Form,
    FormField,
    TextInput,
    Heading,
    Page,
    PageContent,
    Button
} from "grommet";
import {
    getUser,
    updateUserProfile
} from "API/API";
import {AddressAutofill} from "@mapbox/search-js-react";
import {geoCoding, updateUserAddress} from "API/GeoLocation";


type Props = {}

const Profile: React.FC<Props> = (props) => {

    const defaultProfile: API.Profile = {
        Name : "Mortimer",
        FamilyName : "Carrot",
        Email : "name@company.com",
        AboutMe: "",
    }

    const [profile, setProfile] = useState<API.Profile>(defaultProfile)
    const [profileLoaded, setProfileLoaded] = useState<boolean>(false)
    const [address, setAddress] = useState<API.Address>();
    const { user } = useAuth0();

    if(!profileLoaded) {
        getUser(user.sub).then(res => {
            setProfileLoaded(true)
            setProfile(res.Profile)
            setAddress(res.Address)
        })
    }


    const onSubmitProfile = () => {
        updateUserProfile(user.sub, profile).then(err => {
            if (err === 'true') {
                alert("Error submitting profile")
            } else {
                alert("Profile updated successfully")
            }
        })

    }

    const onSubmitAddress = () => {
        geoCoding(address.Postcode,  address.Country).then( locationGeoJSON => {
            address.Location = locationGeoJSON;
            updateUserAddress(user.sub, address)
        })
    }

    return (
        <Page kind={"wide"} >
            <PageHeader
                title={"My Profile"}
                subtitle={"All your veggies to trade"}
                margin={"medium"}
                // actions={ <Button primary label={"Add Produce"} onClick={() => setShowModal(true)} />}
            />
            <PageContent>

                <Grid
                    rows={['medium', 'medium']}
                    columns={['large', 'large']}
                    gap="small"
                    areas={[
                        { name: 'left', start: [0, 0], end: [0, 0] },
                        { name: 'right', start: [1, 0], end: [1, 0] },
                    ]}
                    >


                <Box gridArea="left">
                    <Heading level={2} >Profile</Heading>
                <Form

                    value={profile}
                    onChange={nextValue => setProfile(nextValue)}
                    onSubmit={({ }) => {onSubmitProfile()}}
                >
                    <FormField name="Name" htmlFor="text-input-id" label="Name">
                        <TextInput id="text-input-id" name="Name" placeholder={profile.Name}/>
                    </FormField>
                    <FormField name="FamilyName" htmlFor="text-input-id" label="Family Name">
                        <TextInput id="text-input-id" name="FamilyName" placeholder={profile.FamilyName}/>
                    </FormField>
                    <FormField name="Email" htmlFor="text-input-id" label="Email">
                        <TextInput id="text-input-id" name="Email" placeholder={profile.Email}/>
                    </FormField>
                    <FormField name="AboutMe" htmlFor="text-input-id" label="About Me">
                        <TextInput id="text-input-id" name="AboutMe" placeholder={profile.AboutMe}/>
                    </FormField>

                    <Box direction="row" gap="medium">
                        <Button type="submit" primary label="Update" />
                    </Box>
                </Form>
                </Box>

                <Box gridArea="right">
                    <Heading level={2} >Address</Heading>
                <Form
                    value={address}
                    onChange={nextValue => setAddress(nextValue)}
                    onSubmit={({} ) => {onSubmitAddress()}}
                >
                    <AddressAutofill accessToken={process.env.REACT_APP_MAPBOX_TOKEN}>
                        <FormField name="address" htmlFor="text-input-id" label="Address">
                            <TextInput
                                name="Address" placeholder="Address" type="text"
                                autoComplete="address-line1"
                            />
                        </FormField>
                    </AddressAutofill>

                    <FormField name="city" htmlFor="text-input-id" label="City">
                        <TextInput
                            name="City" placeholder="City" type="text"
                            autoComplete="address-level2"
                        />
                    </FormField>
                    <FormField name="state" htmlFor="text-input-id" label="State">
                        <TextInput
                            name="State" placeholder="State" type="text"
                            autoComplete="address-level1"
                        />
                    </FormField>
                    <FormField name="country" htmlFor="text-input-id" label="Country">
                        <TextInput
                            name="Country" placeholder="Country" type="text"
                            autoComplete="country"
                        />
                    </FormField>
                    <FormField name="postcode" htmlFor="text-input-id" label="ZipCode">
                        <TextInput
                            name="Postcode" placeholder="Postcode" type="text"
                            autoComplete="postal-code"
                        />
                    </FormField>
                <Box direction="row" gap="medium">
                    <Button type="submit" primary label="Update" />
                </Box>
            </Form>
        </Box>

                </Grid>

            </PageContent>
        </Page>
    )
}

export default Profile
